// B3.7 — discovery offer persistence (opt-in, anti-Clippy).

import { LEAD_CAPTURE_TOUR_ID } from "./tours/leadCapture";

/** @deprecated Legacy global dismiss — read for lead-capture migration only. */
const LEGACY_DISCOVERY_DISMISS_KEY = "firefly-tour-discovery-dismissed";
const DISCOVERY_DISMISS_PREFIX = "firefly-tour-discovery-dismissed:";
const COMPLETED_PREFIX = "firefly-tour-completed:";

export function discoveryDismissStorageKey(tourId: string): string {
  return `${DISCOVERY_DISMISS_PREFIX}${tourId.trim()}`;
}

export function tourCompletedStorageKey(tourId: string): string {
  return `${COMPLETED_PREFIX}${tourId.trim()}`;
}

export function isFireflyDiscoveryOfferDismissed(tourId: string): boolean {
  if (typeof window === "undefined") return true;
  try {
    const id = tourId.trim();
    if (window.localStorage.getItem(discoveryDismissStorageKey(id)) === "1") return true;
    if (id === LEAD_CAPTURE_TOUR_ID && window.localStorage.getItem(LEGACY_DISCOVERY_DISMISS_KEY) === "1") {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

export function markFireflyDiscoveryOfferDismissed(tourId: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(discoveryDismissStorageKey(tourId.trim()), "1");
  } catch {
    /* ignore quota */
  }
}

export function isFireflyTourCompleted(tourId: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(tourCompletedStorageKey(tourId)) === "1";
  } catch {
    return false;
  }
}

export function markFireflyTourCompleted(tourId: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(tourCompletedStorageKey(tourId.trim()), "1");
  } catch {
    /* ignore quota */
  }
}
